import apiClient from "@/services/api";

export const loadNotifications = async () => {
  return await apiClient.get("/api/notifications");
};

export const setNotificationsChannel = (userId: number) => {
  return window.Echo.private(`App.Models.User.${userId}`);
};
